import React from 'react';
import {
  ActivityIndicator, StyleSheet, Text, View,
} from 'react-native';
import Moment from 'moment';
import Colors from '../../constants/Colors';
import Style from '../../constants/Style';
import UpArrow12 from '../12pxIcons/UpArrow12';

interface Props {
  data: any;
  liveEnabled: boolean;
  loading: boolean;
}

// function getChangeColor() {
// if (changeValue === 0) {
//   return Colors.light.hereworksBlack400;
// }
// return changeValue < 0 ? Colors.light.hereworksCheckGreen : Colors.light.hereworksRed;
// }

const peopleCount = (title, count, change) => {
  let percentageColor: string = Colors.light.hereworksBlack400;
  if (change < 0) percentageColor = Colors.light.hereworksGreen500;
  else if (change > 0) percentageColor = Colors.light.hereworksRed500;

  return <View style={{ flex: 1 }}>
    <Text style={styles.usage}>{title}</Text>
    <View style={styles.countSection}>
      <Text style={styles.count}>{count}</Text>
      <Text style={styles.ppl}>ppl</Text>
    </View>
    <View style={Style.row}>
      {change > 0 && <UpArrow12 color={percentageColor} />}
      <Text style={[styles.changeText, { color: percentageColor }]}>
        {change === 0 && '~ '}
        {Number.isFinite(change) ? change : '- '}
        {'%'}
      </Text>
    </View>
    <Text style={styles.changeText}>{'Compared to yesterday'}</Text>
  </View>;
};

const timeRow = (title, time, day) => (
  <View style={{ flexDirection: 'row', flex: 1 }}>
    <View style={{ marginRight: 16, flex: 1 }}>
      <Text style={styles.metric}>{`${title} popular time`}</Text>
      <Text style={styles.time}>{time}</Text>
    </View>
    <View style={{ flex: 1 }}>
      <Text style={styles.metric}>{`${title} popular day`}</Text>
      <Text style={styles.time}>{day}</Text>
    </View>
  </View>
);

const PeaksWidget = (props: Props) => {
  const title = 'Peak and least usage';
  const weekdays = props.data.filter((a) => (Moment(a?.key).format('dddd') !== 'Saturday' && Moment(a?.key).format('dddd') !== 'Sunday'));
  // eslint-disable-next-line no-return-assign
  weekdays.forEach((day, index) => day.index = index);

  const peak = weekdays.reduce((a, b) => (a?.score?.value > b?.score?.value ? a : b), null);
  const peakPrevious = peak?.index > 0 ? weekdays[(peak?.index ?? 0) - 1]?.score?.value : 0;
  const peakPreviousChange = (((peak?.score?.value ?? 0) - peakPrevious)
    / (peak?.score?.value ?? 0)) * 100;
  const low = weekdays.reduce((a, b) => (a?.score?.value < b?.score?.value ? a : b), null);
  const lowPrevious = low?.index > 0 ? weekdays[(low?.index ?? 0) - 1]?.score?.value : 0;
  let lowPreviousChange = 0;
  if (low?.score?.value > 0) {
    lowPreviousChange = (((low?.score?.value ?? 0) - lowPrevious)
      / (low?.score?.value ?? 0)) * 100;
  }

  return (<View style={styles.container}>
    <View style={Style.row}>
      <Text style={styles.title}>{title}</Text>
      {props.liveEnabled ? <View style={Style.row}>
        <Text style={[styles.usage, { marginEnd: 8 }]}>LIVE</Text>
        <View>
          <View style={styles.liveCircle} />
          <ActivityIndicator style={{ position: 'absolute' }} animating={props.loading} size={12} color={Colors.light.hereworksRed500} />
        </View>
      </View> : <></>}
    </View>
    <View style={styles.content}>
      {peopleCount('Peak usage', peak?.score?.value ?? 0, Math.floor(peakPreviousChange * 10) / 10)}
      {peopleCount('Least usage', low?.score?.value ?? 0, Math.floor(lowPreviousChange * 10) / 10)}
    </View>
    <View>
      <View style={{ marginVertical: 24, flex: 1 }}>
        {timeRow('Most', `${Moment(peak?.key).format('LT')} - ${Moment(peak?.key).add(1, 'h').format('LT')}`, Moment(peak?.key).format('dddd'))}
      </View>
      {timeRow('Least', `${Moment(low?.key).format('LT')} - ${Moment(low?.key).add(1, 'h').format('LT')}`, Moment(low?.key).format('dddd'))}
    </View>
  </View>);
};

export default PeaksWidget;

const styles = StyleSheet.create({
  container: {
    padding: 16,
    flex: 1,
  },
  title: {
    fontFamily: 'Poppins_400Regular',
    fontSize: 18,
    lineHeight: 27,
    color: Colors.light.hereworksBlack600,
    flex: 1,
  },
  content: {
    flexDirection: 'row',
    flex: 1,
    marginTop: 24,
  },
  usage: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
  },
  countSection: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginTop: 4,
    marginBottom: 8,
  },
  count: {
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 30,
    lineHeight: 30,
    color: Colors.light.hereworksBlack600,
    marginBottom: 2,
  },
  ppl: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 22,
    color: Colors.light.hereworksBlack600,
    marginStart: 4,
  },
  changeText: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
  },
  metric: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 16,
    color: Colors.light.hereworksBlack400,
  },
  time: {
    fontFamily: 'Roboto_500Medium',
    fontSize: 14,
    lineHeight: 16,
    color: Colors.light.hereworksBlack600,
    marginTop: 4,
  },
  liveCircle: {
    width: 12,
    height: 12,
    borderRadius: 6,
    backgroundColor: Colors.light.hereworksRed500,
    borderWidth: 3,
    borderColor: Colors.light.hereworksLightPink,
    marginRight: 12,
  },
});
